export default __webpack_public_path__ + "static/media/ads.b1dc35c7.svg";